import React from "react";

import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import CloseIcon from "@mui/icons-material/Close";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import SectionHeading from "../SectionHeading";
import CardCheckbox from "../../../components/Cardcheckbox";

import { addDonation,setDonationType,setDonationId } from "../../DonationView/slice";

import { DonationStatus } from "../../../common/enum";

import {
  boxStyles,
  buttonStyles,
  cardcheckboxStyles,
  paperStyles,
} from "./styles";

export default function CreateDonationModel({ open, setOpen, t }) {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state);
  const { userId , entityId } = auth.user || {};
  const handleClose = React.useCallback(() => setOpen(false), [setOpen]);

  const handelDonation = async (donationType) => {
    dispatch(
      addDonation({
        entityId: userId,
        createdBy: userId,
        status: DonationStatus.creating,
        isEvent: donationType === "event" ? true : false
      })
    )
      .unwrap()
      .then((response) => {
        dispatch(setDonationId(response.donationId));
        dispatch(setDonationType(donationType));
        navigate("/create-donation");
      })
      .catch((err) => {
        alert("Failed to create donation");
      });
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Paper sx={paperStyles}>
        <Stack spacing={3}>
          <Box sx={boxStyles}>
            <SectionHeading
              heading={"newDonation"}
              paddingLeftStyle="0px"
              subHeading={"selectTypeOfDonation"}
              t={t}
            />
            <Button sx={buttonStyles} onClick={handleClose}>
              <CloseIcon sx={{ color: "#FF0000" }} />
            </Button>
          </Box>
          <Box sx={cardcheckboxStyles}>
            <CardCheckbox
              title={t("donate")}
              icon={"/static/register/donor.png"}
              clickHandler={() => handelDonation("donation")}
              subtitle={t("donateDescription")}
              isCreateDonation
              subtitleFont={12}
              sx={{
                ml:0,
                border:"1px solid #EEEEEE",
                alignItem:"flex-start",
              }}
            />
            <CardCheckbox
              title={t("event")}
              icon={"/static/dashboard/icon-evento.svg"}
              clickHandler={() => handelDonation("event")}
              subtitle={t("eventSub")}
              isCreateDonation
              sx={{
                mr:0,
                border:"1px solid #EEEEEE",
                alignItem:"flex-start",
              }}
              subtitleFont={12}
              isCalendar={{'marginTop':'5px'}}
            />
          </Box>
        </Stack>
      </Paper>
    </Modal>
  );
}
